module.exports = __webpack_public_path__ + "img/icon-facebook.7febcff9.svg";